import { useEffect } from "react"
import { useGetPurchaseQuery } from "shared/redux/endpoints/procurementPurchases"
import { useGetPurchasePaymentContextQuery } from "shared/redux/endpoints/procurementPayments"

// Loads the PO header (supplier, total, budget category) and its payment
// context (remaining, default bank, existing payment count) for one selected
// row, then hands both to the parent. RTK Query caches by id, so the modal
// and the table share the same request.
const PoRowSync = ({ purchaseId, onHydrate }) => {
  const { data: purchase } = useGetPurchaseQuery(purchaseId, { skip: !purchaseId })
  const { data: ctx } = useGetPurchasePaymentContextQuery(purchaseId, { skip: !purchaseId })

  useEffect(() => {
    if (!purchase && !ctx) return
    onHydrate(String(purchaseId), { purchase, ctx })
  }, [purchase, ctx, purchaseId, onHydrate])

  return null
}

export default PoRowSync
